import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData } from "@/js/forms.js";
import { inboundDeliveryStatus } from "@/js/lists.ts";
import AdminInboundDeliveryDetails from "@/components/inbound/AdminInboundDeliveryDetails.vue";
import AdminOrdersSubMenusLinks from "@/components/menu/sub-menus/orders/AdminOrdersSubMenusLinks.vue";
import returnComponent from "@/components/navigation/ReturnToList.vue";
import Error from "@/views/error/error.vue";
export default {
  name: "AdminInboundDeliveryView",
  props: {
    loggedUserData: Object
  },
  components: {
    AdminInboundDeliveryDetails: AdminInboundDeliveryDetails,
    AdminOrdersSubMenusLinks: AdminOrdersSubMenusLinks,
    return: returnComponent,
    Error: Error
  },
  data: function data() {
    return {
      inboundDeliveryId: null,
      isDraft: false,
      isFetching: true,
      fetchInboundDeliveryToken: null,
      inboundDelivery: {
        user: {
          id_user: null
        },
        items: []
      },
      isValid: true,
      error: {
        title: "Order dispatch not found",
        link: "adminOrderList",
        linkTitle: "to orders dispatch",
        params: {
          tab: "inboundDeliveries"
        }
      }
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.inboundDeliveryId = _this2.$route.params.id;
            _context.next = 3;
            return _this2.fetchInboundDelivery();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchInboundDelivery: function fetchInboundDelivery() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$fetchInboundDe;
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              (_this3$fetchInboundDe = _this3.fetchInboundDeliveryToken) === null || _this3$fetchInboundDe === void 0 || _this3$fetchInboundDe.cancel();
              _this3.fetchInboundDeliveryToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 5;
              return request("/v1/inbound/delivery/".concat(_this3.inboundDeliveryId), "get", null, true, "api", null, _this3.fetchInboundDeliveryToken).then(function (response) {
                var _this$inboundDelivery;
                _this.inboundDelivery = response.data.value;
                if (!(((_this$inboundDelivery = _this.inboundDelivery) === null || _this$inboundDelivery === void 0 ? void 0 : _this$inboundDelivery.id) > 0)) {
                  _this.isValid = false;
                } else {
                  _this.isDraft = _this.inboundDelivery.status == inboundDeliveryStatus.find(function (x) {
                    return x.id == "DRAFT";
                  }).status;
                }
                _this.isFetching = false;
              }).catch(function (e) {
                _this.isValid = false;
                _this.isFetching = false;
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch the order dispatch.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};